/**
 * Módulos marcados como "Em construção".
 *
 * O banner aparece a TODOS os utilizadores (incluindo admins) em qualquer rota
 * que comece por um dos prefixos listados. Para libertar um módulo quando
 * estiver pronto, basta remover a entrada deste array.
 *
 * Grupos actualmente marcados:
 *   • CRM        — /customers, /opportunities, /complaints
 *   • Logística  — /logistica, /vehicles
 *   • Comercial  — /vehicle-registrations, /vehicle-quotes
 */
export const UNDER_CONSTRUCTION_PREFIXES = [
  // CRM
  "/customers",
  "/opportunities",
  "/complaints",
  // Logística
  "/logistica",
  "/vehicles",
  // Comercial
  "/vehicle-registrations",
  "/vehicle-quotes",
  // Satisfação / NPS / Feedback do cliente
  "/customer-feedback",
  "/satisfaction-dashboard",
  "/satisfaction-analytics",
];

/** Devolve o nome amigável do grupo para a mensagem do banner. */
export function groupLabelFor(pathname) {
  if (!pathname) return null;
  if (/^\/(customers|opportunities|complaints)/.test(pathname)) return "CRM";
  if (/^\/(logistica|vehicles)/.test(pathname)) return "Logística de Viaturas";
  if (/^\/(vehicle-registrations|vehicle-quotes)/.test(pathname)) return "Comercial";
  if (/^\/(customer-feedback|satisfaction-dashboard|satisfaction-analytics)/.test(pathname)) return "Satisfação & NPS";
  return null;
}

/** True se a rota actual está marcada como em construção. */
export function isUnderConstruction(pathname) {
  if (!pathname) return false;
  return UNDER_CONSTRUCTION_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(p + "/")
  );
}
